module.exports = __webpack_public_path__ + "img/dj_right_rect.15fa2bf1.png";